export function EmailLink({ text }: {text?: string}) {
  return (
    <a href="mailto:vincentcliaw@gmail.com">{text ?? 'vincentcliaw@gmail.com'}</a>
  )
}
